class Currency {
    constructor({ id, name, key, symbol } = {}) {
        this.id = id; // public property
        this.name = name; // public property
        this.key = key; // ISO 2-character country code
        this.symbol = symbol; // ISO 3-character country code
    }
}

export default Currency;
